import React, { Component } from 'react';
import { Modal, Spin, message, Radio, Input, InputNumber } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { TextArea } = Input;
const RadioGroup = Radio.Group;

class BatchConfirm extends Component {
    state = {
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        });
    }
    
    hide = () => {
        this.setState({
            visible: false,
            radioVal: '',
        });
    }

    confirm = () => {
        if (this.state.radioVal == 0) {
            this.confirmOnePage();
        } else {
            this.confirmAllTotal();
        }
    }

    confirmOnePage = () => {
        const { data } = this.props;
        const ids = {}
        const params = {};
        let id = 0;
        data.map((item, index) => {
            const { status, isComfirm, investgationSiteUserFteMonthSummaryId } = item;
            if (isComfirm === "1") {
                ids[id] = investgationSiteUserFteMonthSummaryId;
                id++;
            }
            if (status !== 'VERIFY' && isComfirm === "1") {
                params[`unconfirmedHourViewList[${index}].hourType`] = 'investigation';
                params[`unconfirmedHourViewList[${index}].hourId`] = investgationSiteUserFteMonthSummaryId;
            }
        });
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.comfirmUserFteMonthOffset,
            data: {
                ids,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.completeInvMessage) {
                    message.info(res.completeInvMessage);
                } else if (res.invJde) {
                    message.info(res.invJde);
                } else if (res.siteJde) {
                    message.info(res.siteJde);
                } else if (res.endTimeOverComment) {
                    message.info(res.endTimeOverComment);
                } else if (res.noData) {
                    message.info(res.noData);
                } else if (res.success) {
                    message.info(res.success);
                }
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    confirmAllTotal = () => {
        const { searchParams } = this.props;
        this.setState({ loading: false });
        const options = {
            url: API_URL.execute.comfirmUserFteMonthAll,
            data: { ...searchParams },
            dataType: 'json',
            doneResult: res => {
                if (res.completeInvMessage) {
                    message.info(res.completeInvMessage);
                } else if (res.invJde) {
                    message.info(res.invJde);
                } else if (res.siteJde) {
                    message.info(res.siteJde);
                } else if (res.endTimeOverComment) {
                    message.info(res.endTimeOverComment);
                } else if (res.noData) {
                    message.info(res.noData);
                } else if (res.success) {
                    message.info(res.success);
                } else if (res.siteContractRelate){
                    message.error(res.success);
                } else if (res.pmConfirmPercent){
                    message.info(res.pmConfirmPercent);
                }
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleChange = (e) => {
        this.setState({ radioVal: e.target.value });
    }

    render() {
        const { visible, radioVal, loading } = this.state;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Modal
                title="批量操作"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                confirmLoading={loading}
                className="preview-modal"
                maskClosable={false}
                width="400px"
            >
                <div style={{ padding: '30px 40px' }}>
                    <h2 style={{ marginBottom: 20 }}>请选择批量确认操作数据对象</h2>
                    <RadioGroup onChange={this.handleChange} value={radioVal}>
                        <Radio style={radioStyle} value={0}>当前页数据</Radio>
                        <Radio style={radioStyle} value={1}>所有数据</Radio>
                    </RadioGroup>
                </div>
            </Modal>
        );
    }
}

class ModifyManhour extends Component {
    state = {
        record: {},
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
            params: {
                duration: record.durationStringNoH
            },
        });
    }
    
    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { record, params } = this.state;
        const { manHourId, remarks } = record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.manhour.editmanhour,
            data: {
                manHourId,
                remarks,
                ...params,
            },
            dataType: 'json',
            doneResult: data => {
                message.success(data.data.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    render() {
        const { visible, loading, params: { duration } } = this.state;
        return (
            <Modal
                title="修改工时"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                confirmLoading={loading}
                className="preview-modal"
                maskClosable={false}
                width="400px"
            >
                <div className="modal-content" style={{ padding: '30px 40px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '45%' }}>工时数：</div>
                            <div className="item-right" style={{ width: '55%' }}>
                                <InputNumber min={0} max={24} value={duration} onChange={value => this.handleChange(value, 'duration')} step={0.01} style={{ marginRight: 6, width: 100 }} />
                                h
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

class InformModify extends Component {
    state = {
        record: {},
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            params: {},
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { record: { investgationSiteUserFteMonthSummaryId } } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.queryManHourNoticeMemory,
            data: {
                hourType: 'investigation',
                hourId: investgationSiteUserFteMonthSummaryId,
                investigationSiteUserFteMonthSummaryId: investgationSiteUserFteMonthSummaryId,
            },
            dataType: 'json',
            doneResult: res => {
                const { params } = this.state;
                params.modifyContent = res.success ? res.success.content : '';
                this.setState({ params, loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }
    
    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { record, params } = this.state;
        const { investgationSiteUserFteMonthSummaryId } = record;
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.createManHourNoticeModify,
            data: {
                hourType: 'investigation',
                hourId: investgationSiteUserFteMonthSummaryId,
                investigationSiteUserFteMonthSummaryId: investgationSiteUserFteMonthSummaryId,
                ...record,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    render() {
        const { visible, loading, params: { modifyContent } } = this.state;
        return (
            <Modal
                title="通知修改"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <Spin spinning={loading}>
                    <div style={{ padding: '30px 40px' }}>
                        修改说明：<TextArea rows={4} value={modifyContent} onChange={e => this.handleChange(e, 'modifyContent')} style={{ width: "250px", verticalAlign: "top" }} />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

class ConfigMainCrc extends Component {
    state = {
        type: '',
        data: [],
        record: {},
        visible: false,
        loading: false,
        distributeRatio: [],
    }

    show = (record, type) => {
        this.setState({
            type,
            record,
            data: [],
            visible: true,
        }, () => {
            if (type === 'add') {
                this.queryDistributeRatio();
            } else {
                this.loadData();
            }
        });
    }

    loadData = () => {
        const { type, distributeRatio, record: { userId, yearNum, monthNum, investigationSiteId } } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.queryMainCrcList,
            data: {
                yearNum,
                monthNum,
                investigationSiteId,
            },
            dataType: 'json',
            doneResult: res => {
                const { list } = res;
                let assignWeight;
                if (type === 'add') {
                    let mainRatio;
                    let minorRatio;
                    distributeRatio.forEach(i => {
                        const { typeValue, weightValue } = i;
                        if (typeValue === '主要CRC') {
                            mainRatio = weightValue;
                        } else {
                            minorRatio = weightValue;
                        }
                    });
                    const leftCrc = list.length - 1;
                    const aveMinorRatio = (minorRatio / leftCrc).toFixed(2);
                    list.forEach(i => {
                        if (i.userId === userId) {
                            i.mainCrc = 1
                            i.assignWeight = mainRatio;
                        } else {
                            i.assignWeight = aveMinorRatio;
                        }
                    });
                    assignWeight = mainRatio + aveMinorRatio * leftCrc;
                } else {
                    list.forEach(i => i.assignWeight *= 100);
                    assignWeight = 100;
                }
                list.unshift({
                    userId: 'head',
                    userCompellation: 'CRC',
                    mainCrc: '主要CRC',
                    assignWeight: '访视数分配系数',
                });
                list.push({
                    userId: 'foot',
                    userCompellation: '合计',
                    assignWeight,
                });
                this.setState({
                    data: list,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryDistributeRatio = () => {
        const { maxMonth } = this.props;
        const { record: { date } } = this.state;
        const url = moment(date).valueOf() >= moment(maxMonth).valueOf() ? API_URL.execute.queryPerformanceWeightByType : API_URL.execute.queryHistoryPerformanceWeight;
        const options = {
            method: 'POST',
            url,
            data: {
                date,
                type: 'DISTRIBUTION',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ distributeRatio: res.data }, () => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }
    
    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { data, record } = this.state;
        const { yearNum, monthNum, investigationSiteId } = record;
        let idx = 0;
        const params = {};
        for (let i = 1, len = data.length; i < len; i++) {
            const { userId, userCompellation, mainCrc, assignWeight } = data[i];
            if (i < (len - 1)) {
                if (!assignWeight && assignWeight !== 0) {
                    message.warning(`请分配CRC${userCompellation}的访视数系数！`);
                    return;
                }
                params[`siteCrcViewList[${idx}].userId`] = userId;
                params[`siteCrcViewList[${idx}].mainCrc`] = mainCrc;
                params[`siteCrcViewList[${idx}].assignWeight`] = assignWeight;
                idx++;
            } else {
                const parseAssignWeight = assignWeight.toFixed(2);
                if (parseAssignWeight != 100) {
                    message.warning(`请确保各CRC的访视数分配系数之和为100%！`);
                    return;
                }
            }
        }
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.saveSiteMainCrc,
            data: {
                yearNum,
                monthNum,
                investigationSiteId,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getNumber = (value) => {
        var number = parseFloat(value);
        return (number && ((number !== number || 0 ) || number)) || 0;
    }

    handleRadioChange = (e, idx) => {
        const { data } = this.state;
        data.forEach((item, index) => {
            if (index > 0) {
                if (idx === index) {
                    item.mainCrc = 1;
                } else {
                    item.mainCrc = 0;
                }
            }
        });
        this.setState({ data });
    }

    handleNumberChange = (value, index) => {
        const { data } = this.state;
        data[index].assignWeight = value;
        let total = 0;
        const lastIndex = data.length - 1;
        data.forEach((item, index) => {
            if (index !== 0 && index !== lastIndex) {
                total += this.getNumber(item.assignWeight);
            }
        });
        data[lastIndex].assignWeight = total;
        this.setState({ data });
    }

    getContent = () => {
        const { data, type } = this.state;
        const result = [];
        data.forEach((item, index) => {
            const { userId, userCompellation, employeeCode, mainCrc, assignWeight, hourStatus } = item;
            if (index === 0) {
                result.push(
                    <li key={userId} className="flexRow head">
                        <div className="flexItem">{userCompellation}</div>
                        { type === 'add' && <div className="flexItem">{mainCrc}</div> }
                        <div className="flexItem">{assignWeight}</div>
                    </li>
                );
            } else if (index === (data.length - 1)) {
                result.push(
                    <li key={userId} className="flexRow foot borderTop">
                        <div className="flexItem">{userCompellation}</div>
                        { type === 'add' && <div className="flexItem">&nbsp;</div> }
                        <div className="flexItem">{assignWeight.toFixed(2)}<span style={{ marginLeft: 10 }}>%</span></div>
                    </li>
                );
            } else {
                result.push(
                    <li key={userId} className="flexRow">
                        <div className="flexItem">{`${userCompellation}[${employeeCode}]`}</div>
                        {
                            type === 'add' && 
                            <div className="flexItem">
                                <Radio checked={mainCrc === 1} onChange={e => this.handleRadioChange(e, index)}>主要CRC</Radio>
                            </div>
                        }
                        <div className="flexItem">
                            {
                                // hourStatus === 'VERIFY' ?
                                //     assignWeight.toFixed(2)
                                // :
                                    <InputNumber
                                        min={0}
                                        max={100}
                                        precision={2}
                                        value={assignWeight}
                                        style={{ width: 70, marginRight: 10 }}
                                        onChange={value => this.handleNumberChange(value, index)}
                                    />
                            }
                            %
                        </div>
                    </li>
                );
            }
        });
        return result;
    }

    render() {
        const { type, visible, loading, record } = this.state;
        const { investigationSiteName, investigationSiteCode } = record;
        const title = (type === 'add' && '设置主要CRC') || (type == 'edit' && '修改访视数分配系数')
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <Spin spinning={loading}>
                    <div style={{ padding: 20 }}>
                        <div>中心：{investigationSiteName}（{investigationSiteCode}）</div>
                        <ul className="flexTable">
                            {this.getContent()}
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export { BatchConfirm, ModifyManhour, InformModify, ConfigMainCrc };


// WEBPACK FOOTER //
// ./src/components/execute/manHour/Widget.js